
    module.exports = {
      render: function(){with(this){return _c('li',[_c('div',{class:['sidebar-icon', icon]}),_c('a',{class:{ active: isActive },attrs:{"href":href}},[_v(_s(text())),(badge)?_c('span',{staticClass:"sidebar-badge"},[_v(_s(badge))]):_e()])])}},
      staticRenderFns: []
    };
  